import React, { useState, useEffect } from 'react';
import './css/eventform.css';
import { useNavigate } from 'react-router-dom';
import { FaCalendarAlt, FaMapMarkerAlt, FaPlusCircle , FaArrowCircleLeft, FaArrowCircleRight, FaTicketAlt } from "react-icons/fa";
import { API_URL_BASE } from './config';

const CreateTicketsForm = ({ eventId, eventType, eventData, onSuccess, onBack , addedTickets, onTicketsChange, showForm, onShowFormChange}) => {
	const navigate = useNavigate();
	const [token, setToken] = useState('');
	const [message, setMessage] = useState('');
	const [hideTicketPrice, setHideTicketPrice] = useState(false);

	const [formData, setFormData] = useState({
		ticketName: '',
		ticketPrice: '',
		ticketCapacity: '',
	});

	const handleReset = () => {
		setFormData({ ticketName: '', ticketPrice: '', ticketCapacity: '' });
	};

	useEffect(() => {
		const storedToken = localStorage.getItem('token');
		if (storedToken) {
			setToken(storedToken);
		} else {
			console.warn("No token found in localStorage");
			navigate("/");
		}
	}, []);

	useEffect(() => {
		if (eventType === 'FREE') {
			setHideTicketPrice(true);
			setFormData((prev) => ({ ...prev, ticketName: 'Free Ticket', ticketPrice: 0 }));
		}
	}, [eventType]);

	const handleChange = (e) => {
		const { name, value } = e.target;
		setFormData({ ...formData, [name]: value });
	};

	const handleNext = () => {
		onSuccess("NEXT");
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		try {
			const response = await fetch(API_URL_BASE + '/ticket.json', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					saveticket: {
						token: token,
						newticket: {
							eventid: eventId,
							name: formData.ticketName,
							price: (formData.ticketPrice * 100),
							capacity: formData.ticketCapacity,
							ticketsold: 0
						}
					}
				})
			});

			if (!response.ok) throw new Error(`Server error: ${response.status}`);

			const result = await response.json();

			if (result && result.message) {
				onTicketsChange(prev => [...prev, {
					name: formData.ticketName,
					price: formData.ticketPrice,
					capacity: formData.ticketCapacity,
				}]);
				setMessage('');
				onShowFormChange(false);
				handleReset();
			} else {
				throw new Error("Ticket creation failed");
			}
		} catch (e) {
			setMessage(e.message || "An unexpected error occurred while creating the ticket.");
		}
	};

	return (
		<div>
			<section className="main-content">

			{/* Event summary card */}
			{eventData && (
				<div className="ticket-event-summary">
					{eventData.eventImage && (
						<img
							src={`data:image/png;base64,${eventData.eventImage}`}
							alt={eventData.eventName}
							className="ticket-event-summary-img"
						/>
					)}
					<div className="ticket-event-summary-info">
						<h3>{eventData.eventName}</h3>
						{eventData.address && (
							<p><FaMapMarkerAlt className="ticket-summary-icon" /> {eventData.address}</p>
						)}
						{eventData.eventStartDate && (
							<p>
								<FaCalendarAlt className="ticket-summary-icon" />
								{new Date(eventData.eventStartDate).toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' })}
								{' → '}
								{eventData.eventEndDate
									? new Date(eventData.eventEndDate).toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' })
									: ''}
							</p>
						)}
						<p><span className="event-saved-type">{eventData.eventDesc}</span></p>
					</div>
				</div>
			)}
			
				{/* Added tickets list — shown once at least one ticket is saved */}
				{addedTickets.length > 0 && (
					<div className="added-tickets-list">
						<h3>Tickets Added</h3>
						{addedTickets.map((t, i) => (
							<div key={i} className="added-ticket-row">
								<span className="added-ticket-name"><FaTicketAlt/> {t.name}</span>
								{!hideTicketPrice && <span className="added-ticket-price">€ {parseFloat(t.price).toFixed(2)}</span>}
								<span className="added-ticket-capacity">{t.capacity} tickets</span>
							</div>
						))}
					</div>
				)}

				{/* Add ticket button — shown when form is hidden */}
				{!showForm && (
					<div className="ticket-next-action">
						<button className="submit-btn btn-secondary" type="button" onClick={onBack}><FaArrowCircleLeft style={{paddingRight:'10px'}}/>Previous</button>
						<button className="submit-btn btn-primary" onClick={() => onShowFormChange(true)}>
							<FaPlusCircle style={{paddingRight:'10px'}}/>{addedTickets.length === 0 ? 'Add Tickets to this Event' : 'Add Another Ticket'}
						</button>
						{addedTickets.length > 0 && (
							<button className="submit-btn" onClick={handleNext}>Next<FaArrowCircleRight style={{paddingLeft:'10px'}}/></button>
						)}
					</div>
				)}
				

				{/* Ticket form */}
				{showForm && (
					<div className="ticket-form-section">
						<h2>{addedTickets.length === 0 ? 'Create New Ticket' : 'Add Another Ticket'}</h2>
						{message && <p className="error-text">{message}</p>}
						<div className="event-form-container">
							<form onSubmit={handleSubmit} className="event-form">
								<label className="event-form">Ticket Name<span className="required-asterisk">*</span></label>
								<input type="text" name="ticketName" value={formData.ticketName} onChange={handleChange} required />

								{!hideTicketPrice && (
									<>
										<label className="event-form">Ticket Price<span className="required-asterisk">*</span></label>
										<input type="number" name="ticketPrice" value={formData.ticketPrice} onChange={handleChange} required className="no-spinner" />
									</>
								)}

								<label className="event-form">Total number of Tickets<span className="required-asterisk">*</span></label>
								<input type="number" name="ticketCapacity" value={formData.ticketCapacity} onChange={handleChange} required className="no-spinner" />

								<button type="submit" className="submit-btn">Add Ticket</button>
							</form>
						</div>
					</div>
					)}

			</section>
		</div>
	);
};

export default CreateTicketsForm;
